import { getDefaultTransition, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReviewEntryAiReasoningWrapper = styled.div<{ isAnimated: boolean; maxHeight: number }>`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: ${Spacing.S8};
  max-height: ${({ maxHeight }) => `${maxHeight}px`};
  overflow: hidden;
  ${({ isAnimated }) => (isAnimated ? getDefaultTransition('max-height') : '')}
`

export const ReviewEntryAiReasoningToggle = styled.button`
  display: flex;
  align-items: center;
  align-self: flex-start;
  gap: ${Spacing.S4};
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`
